
const _url="//www.streevr.com/svstpApi";  //正式地址
// const _url="//10.0.0.254:8081";   //测试地址
import { httpPost,httpGet } from "./http";
export const homeSearch =(data)=> {
   return httpPost(_url+'/home/search',data)
}
// 查询新闻资讯列表
export const getNoticeallEnableColumnt=(data)=>{
    return httpGet(_url+'/notice/column/allEnableColumn',data) 
}
// 查询新闻资讯列表
 export const getNoticelist=(data)=>{
    return httpPost(_url+'/notice/list',data) 
}
// 查询资讯详情
export const getNoticeDetail = (data)=>{
    return httpGet(_url+'/notice/getDetail',data) 
}
// 获取首页banner
export const getBannerList = (data)=>{
    return httpGet(_url+'/sys/banner/list',data) 
}
// 获取学习记录-实验记录-下拉列表-全部实验
export const getExperimentSelect=(data)=>{
    return httpGet(_url+'/course/extend/getExperimentSelect',data) 
}
//学习记录-实验记录-下拉列表-全部章节
export const getExperimentCatalogSelect=(data)=>{
    return httpGet(_url+'/course/extend/getExperimentCatalogSelect',data) 
}
//通过考试记录id获取考试详情(考试记录id为提交考卷返回结果中的id)
export const getRecord=(data)=>{
    return httpGet(_url+'/el/exam/record/get',data) 
}
// 获取系统配置
export const geSysConfig=(data)=>{
    return httpGet(_url+'/sys/config/get',data) 
}
// 获取有权限的菜单
export const getprivilegeConfig=(data)=>{
    return httpGet(_url+'/sys/privilege/get',data) 
}
// 获取教育层级 
export const getEducationLevel=(data)=>{
    return httpGet(_url+'/course/getEducationLevel',data) 
}
// 记录点击开始学习接口
export const goStudy=(data)=>{
    return httpGet(_url+'/course/goStudy',data) 
}
// 获取后台管理地址 /auth/getBackgroundUrl 
export const getBackgroundUrl=(data)=>{
    return httpGet(_url+'/auth/getBackgroundUrl',data) 
}
export default {
    webSocketURL: `ws:${_url}/ws/user`,
    img_url:`${_url}`,
    auth_getImageCaptcha:`${_url}/auth/getImageCaptcha`,//获取登录验证码
    auth_login:`${_url}/auth/login`,//登录
    auth_register:`${_url}/auth/register`,//用户注册
    auth_getPhoneCaptcha:`${_url}/auth/getPhoneCaptcha`,//获取手机验证码
    auth_getUserInfo:`${_url}/auth/getUserInfo`,//查询用户信息
    auth_logout:`${_url}/auth/logout`,//退出登录
    course_list:`${_url}/course/list`,//课程分页查询
    course_getAllSubject:`${_url}/course/getAllSubject`,//筛选条件的专业树
    course_getStatistics:`${_url}/course/getStatistics`,//课程统计数据
    course_get:`${_url}/course/get`,//课程详情
    course_extend_getTeacher:`${_url}/course/extend/getTeacher`,//师资介绍
    course_extend_getExtendData:`${_url}/course/extend/getExtendData`,//栏目详情(富文本)
    course_extend_getExperimentRecord:`${_url}/course/extend/getExperimentRecord`,//学习记录-实验记录
    course_extend_getExperimentDetail:`${_url}/course/extend/getExperimentDetail`,//学习记录-操作详情
    course_extend_getCatalogResource:`${_url}/course/extend/getCatalogResource`,//课程资料
    course_evaluation_list:`${_url}/course/evaluation/list`,//课程评价列表
    course_evaluation_create:`${_url}/course/evaluation/create`,//新增课程评价
    course_link_get:`${_url}/course/link/get`,//通过课程id获取期次信息
    course_collect_add:`${_url}/course/collect/add`,//收藏课程
    course_collect_del:`${_url}/course/collect/del`,//取消课程收藏
    course_like_add:`${_url}/course/like/add`,//课程点赞
    course_like_del:`${_url}/course/like/del`,//取消课程点赞
    course_extend_getAllItem:`${_url}/course/extend/getAllItem`,//课程详情导航栏配置信息
    course_extend_getDataAnalysis:`${_url}/course/extend/getDataAnalysis`,//数据分析
    course_question_list:`${_url}/course/question/list`,//问答讨论提问
    course_answer_list:`${_url}/course/answer/list`,//问答讨论回答
    course_extend_getCourseEvaluate:`${_url}/course/extend/getCourseEvaluate`,//课程评审
    home_getStatistics:`${_url}/home/getStatistics`,//首页统计数据
    course_extend_getCatalog:`${_url}/course/extend/getCatalog`,//课程目录
    course_question_create:`${_url}/course/question/create`,//新增问题
    course_answer_create:`${_url}/course/answer/create`,//回答问题
    el_exam_getInfo:`${_url}/el/exam/getInfo`,//通过考试id获取考试详情
    el_exam_record_submitExam:`${_url}/el/exam/record/submitExam`,//提交考卷
    ums_my_getStatOverview:`${_url}/ums/my/getStatOverview`,//获取统计概况
    ums_my_getExperiment:`${_url}/course/getExperiment`,//个人中心-获取实验
    course_getCourse:`${_url}/course/getCourse`,//个人中心-获取我的课程
    // ums_my_getCollect:`${_url}/ums/my/getCollect`,//个人中心-获取收藏
    ums_my_getCollect:`${_url}/course/collect/getCollect`,//个人中心-获取收藏
    ums_my_getLastWeekStat:`${_url}/ums/my/getLastWeekStat`,//获取最近八周详情
    ums_my_getStatByDate:`${_url}/ums/my/getStatByDate`,//获取统计详情
    sys_semester_all:`${_url}/sys/semester/all`,//获取全部学期
    ums_my_updatePassword:`${_url}/ums/my/updatePassword`,//修改密码
    ums_my_update:`${_url}/ums/my/update`,//修改个人信息
    home_courseClassify_all:`${_url}/home/courseClassify/all`,//查询所有课程分类
    home_courseList:`${_url}/home/courseList`,//通过课程分类获取热门课程
    home_experimentList:`${_url}/home/experimentList`,//获取热门实训
    home_ranking:`${_url}/home/ranking`,//排行榜查询

    msgPush_list:`${_url}/msgPush/list`,//分页查询消息
    msgPush_allSetRead:`${_url}/msgPush/allSetRead`,//全部已读
    file_singleUpload:`${_url}/file/singleUpload`,//文件上传
    ums_my_getOldPhoneCaptcha:`${_url}/ums/my/getOldPhoneCaptcha`,//获取旧手机验证码
    ums_my_getNewPhoneCaptcha:`${_url}/ums/my/getNewPhoneCaptcha`,//获取新手机验证码
    ums_my_checkCaptcha:`${_url}/ums/my/checkCaptcha`,//校验原手机号码
    ums_my_bindPhone:`${_url}/ums/my/bindPhone`,//绑定手机号
    ums_my_getOldEmailCaptcha:`${_url}/ums/my/getOldEmailCaptcha`,//获取旧邮箱验证码
    ums_my_checkEmailCaptcha:`${_url}/ums/my/checkEmailCaptcha`,//校验原邮箱
    ums_my_getNewEmailCaptcha:`${_url}/ums/my/getNewEmailCaptcha`,//获取新邮箱验证码
    ums_my_bindEmail:`${_url}/ums/my/bindEmail`,//绑定邮箱
    5:`${_url}/`,//
    6:`${_url}/`,//
    7:`${_url}/`,//

    msgPush_send_notice:`${_url}/msgPush/send/notice`,//发布公告消息测试
    file_getDownLoadUrl:`${_url}/file/getDownLoadUrl`,//获取下载地址

}
